import './profile.scss';
import useAuth from "../../hooks/useAuth";
import { useEffect, useState } from 'react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

const Profile = () => {
  const { auth } = useAuth();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    const getUser = async () => {
      try {
        const response = await axiosPrivate.get(`/users/${auth.username}`);
        if (response?.data) setUser(response.data);
      } catch (err) {
        console.error("Error fetching user:", err);
        
      } finally {
        setLoading(false);
      }
    };
    getUser();
  }, [auth.username, axiosPrivate]);


  if (loading) return <p className="profile">Loading profile...</p>;

  if (!user) return <p className="profile">No Profile found</p>;


  // if the API returns an array (just in case)
  const users = Array.isArray(user) ? user : [user];

  return (
    <div className="profile">
      <br />
      <h2>My Profile</h2><br />
      <div className="view">
        {users.map((u) => (
          
            <div className="info" key={`${u.userEmail}`}>
              <div className="topInfo">
                <div className="initials">
                  {u.fullName
                    ?.split(' ')
                    .map((i) => i[0])
                    .join('')
                    .toUpperCase()}
                </div>
                <h3>{u.fullName}</h3>
              </div>
            

            <div className="details">

              <div className="item">
                <span className="itemTitle">Username:</span>
                <span className="itemValue">{u.username}</span>
              </div>

              <div className="item">
                <span className="itemTitle">Roles:</span>
                <span className="itemValue">
                  {Array.isArray(u.roles)
                    ? u.roles.join(', ')
                    : typeof u.roles === 'object'
                      ? Object.keys(u.roles).join(', ')
                      : u.roles}
                </span>
              </div>

              <div className="item">
                <span className="itemTitle">Email:</span>
                <span className="itemValue">{u.userEmail}</span>
              </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Profile;
